export default __webpack_public_path__ + "static/MullerRegular-d23c2eb5e9ac7caa775bac21383fd5d9.woff2";